import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import signature from "../../content/assets/signature.png"

const Page = styled.div`
  background-color: #c8d6e5;
`

const Header = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 30px;
  h1,
  h3,
  a {
    font-size: 2rem;
    line-height: 1rem;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  background: white;
  img {
    height: 100px;
  }
  h5 {
    margin: 0;
  }
  span,
  span a {
    color: grey;
  }
`

class Layout extends React.Component {
  render() {
    const { title, children } = this.props
    let header = (
      <h3
        style={{
          fontFamily: `Montserrat, sans-serif`,
          padding: 0,
          margin: 0,
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
      </h3>
    )
    return (
      <Page
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
        }}
      >
        <Header>{header}</Header>
        <main>{children}</main>
        <Footer>
          <img src={signature} alt="daniel kunkels signature" />
          <h5>
            Daniel J. Kunkel &copy; 2019 -{" "}
            <span>
              made by <a href="https://jackgisel.com">jack gisel</a>
            </span>
          </h5>
        </Footer>
      </Page>
    )
  }
}

export default Layout
